import Util from '@baifendian/adhere-util';
import { gridCount } from './Fixed';
/**
 * getHorizontalGridStyle
 * @param {number} gapOrigin
 * @param media
 * @return {React.CSSProperties}
 */
var getHorizontalGridStyle = function (_a) {
  var gapOrigin = _a.gapOrigin,
    media = _a.media;
  var gridLayout = {};
  var gapValue = getValueWithUnit(gapOrigin / 2, media);
  gridLayout.paddingLeft = gapValue;
  gridLayout.paddingRight = gapValue;
  return gridLayout;
};
/**
 * getVerticalGridStyle
 * @param {number} span
 * @param {ReactNode[]} children
 * @param {number} gapOrigin
 * @param media
 * @return {React.CSSProperties}
 */
var getVerticalGridStyle = function (_a) {
  var span = _a.span,
    children = _a.children,
    gapOrigin = _a.gapOrigin,
    media = _a.media;
  var gridStyle = {};
  var gapValue = getValueWithUnit(gapOrigin / 2, media);
  // 栅格设置
  if (span) {
    var heightGap = (children.length - 1) * gapOrigin;
    // (100% - 所有栅格间隙的高度) * (span / 24)
    // gridStyle.height = `calc( (100% - ${gapHeight}px) * (${span}/${gridCount}) )`;
    gridStyle.height = "calc( (100% - ".concat(getValueWithUnit(heightGap, media), ") * (").concat(span, "/").concat(gridCount, ") )");
  }
  // 设置paddingTop和paddingBottom
  gridStyle.paddingTop = gapValue;
  gridStyle.paddingBottom = gapValue;
  return gridStyle;
};
/**
 * getGridStyle
 * @description 获取栅格系统的样式
 * @param {number | number[]} gutter gird的间隙
 * @param {'vertical' | 'horizontal'} direction 方向
 * @param {number} span 栅格的值
 * @param {React.ReactNode[]} children 孩子
 * @param media
 * @return {React.CSSProperties}
 */
export var getGridStyle = function (_a) {
  var _b, _c;
  var gutter = _a.gutter,
    span = _a.span,
    _d = _a.children,
    children = _d === void 0 ? [] : _d,
    _e = _a.direction,
    direction = _e === void 0 ? 'vertical' : _e,
    media = _a.media;
  var gapOrigin = 0;
  if (Array.isArray(gutter)) {
    if (gutter.length === 1) {
      gapOrigin = gutter[0];
    } else if (gutter.length === 2) {
      if (direction === 'horizontal') {
        gapOrigin = gutter[1];
      } else if (direction === 'vertical') {
        gapOrigin = gutter[0];
      } else {
        gapOrigin = gutter[0];
      }
    }
  } else {
    gapOrigin = gutter;
  }
  var map = new Map([[
  // 横向
  'horizontal', function () {
    return getHorizontalGridStyle({
      gapOrigin: gapOrigin,
      media: media
    });
  }], [
  // 纵向
  'vertical', function () {
    return getVerticalGridStyle({
      span: span,
      children: children,
      gapOrigin: gapOrigin,
      media: media
    });
  }]]);
  return (_c = (_b = map.get(direction)) === null || _b === void 0 ? void 0 : _b()) !== null && _c !== void 0 ? _c : {};
};
export function getValueWithUnit(pixel, media) {
  if (Util.isString(pixel)) return pixel;
  var value = getValue(pixel, media);
  if (media === null || media === void 0 ? void 0 : media.isUseMedia) {
    return "".concat(value, "rem");
  }
  return "".concat(value, "px");
}
export function getValue(pixel, media) {
  if (media === void 0) {
    media = {
      isUseMedia: false,
      designWidth: 192
    };
  }
  if (media.isUseMedia) {
    return Util.pxToRemNumber(pixel, media.designWidth);
  }
  return pixel;
}